<template>
    <div class="dsclf">
        <div class="calc-templete">
            <h6>勘察费计算模版</h6>
            <t-form :data="formData" :rules="rules" ref="form" @reset="onReset" @submit="onSubmit">
                <t-row style="height: auto;align-items: stretch;">
                    <t-col :span="6"
                        style="border-right: 1px solid #DADDE1;padding-left: 40px;padding-right: 140px;padding-bottom: 50px;height: auto;">
                        <div class="left-top-title"><span>{{ name }}</span></div>
                        <t-form-item label="计算依据">
                            <a class="file-name" v-if="fileList" @click="fileOpenDialog(fileList.url)">{{
                                fileList.fileName
                                }}</a>
                            <a v-else class="no-file-name">无文件</a>
                            <!-- <t-input v-model="formData.projectName" placeholder="请输入工程名称" ></t-input> -->
                        </t-form-item>
                        <t-form-item label="工程名称" name="projectName">
                            <t-input v-model="formData.projectName" placeholder="请输入工程名称"></t-input>
                        </t-form-item>

                        <t-form-item label="实物工作量" name="money">
                            <t-input-number v-model="formData.money" placeholder="请输入实物工作量" suffix="km"
                                type="number" :min="0" theme="normal"></t-input-number>
                        </t-form-item>

                        <t-form-item label="选择复杂程度" name="complexCoefficient">
                            <t-select v-model="formData.complexCoefficient" placeholder="请选择复杂程度">
                                <t-option key="1" label="简单" value="1" />
                                <t-option key="2" label="中等" value="2"></t-option>
                                <t-option key="3" label="复杂" value="3" />

                            </t-select>
                            <t-popup placement="right" showArrow>
                                <template #content>
                                    <div>请确定好比例标准</div>
                                </template>
                                <t-button theme="default" variant="outline" class="coefficient">查看说明

                                </t-button>
                            </t-popup>


                        </t-form-item>

                        <t-form-item label="附加调整" name="additionalAdjustments">
                            <t-select v-model="formData.additionalAdjustments" placeholder="请选择附加调整">
                                <t-option key="1.0" label="1.0" value="1.0" />
                                <t-option key="1.5" label="1.5" value="1.5"></t-option>


                            </t-select>
                            <t-popup placement="right" showArrow>
                                <template #content>
                                    <div>默认系数为1<br />
                                        滨海区，附加调整系数为1.5</div>
                                </template>
                                <t-button theme="default" variant="outline" class="coefficient">查看说明

                                </t-button>
                            </t-popup>


                        </t-form-item>

                        <t-form-item label="气温附加调整" name="airCoefficient">
                            <t-select v-model="formData.airCoefficient" placeholder="请选择气温附加调整系数">
                                <t-option key="1.0" label="1.0" value="1.0" />
                                <t-option key="1.2" label="1.2" value="1.2"></t-option>


                            </t-select>
                            <t-popup placement="right" showArrow>
                                <template #content>
                                    <div>在气温以地气象台、站的气象报告为235°C或者&lt;-10°C条件下<br />
                                        进行勘查作业时,气温附加调整系数为1.2</div>
                                </template>
                                <t-button theme="default" variant="outline" class="coefficient">查看说明

                                </t-button>
                            </t-popup>


                        </t-form-item>

                        <t-form-item label="高程调整" name="airCoefficient">
                            <t-input v-model="formData.elevationCoefficient" placeholder="请输入高程调整系数"
                                style="width: 320px;"></t-input>
                            <t-button theme="default" variant="outline" class="coefficient" @click="openVisible3">点击选择
                            </t-button>


                        </t-form-item>



                        <t-form-item label="浮动幅度" name="floatingRange">
                            <t-input-number v-model="floatingRange" placeholder="" suffix="%" :status="inputStatus3"
                                :tips="tips3" :min="0" theme="normal"></t-input-number>
                            <t-popup placement="right" showArrow>
                                <template #content>
                                    <div>国家标准:80%~120%</div>
                                </template>
                                <t-button theme="default" variant="outline" class="coefficient">查看说明

                                </t-button>
                            </t-popup>
                        </t-form-item>



                        <t-form-item label="让利利率" name="discountRate">
                            <t-input-number v-model="discountRate" placeholder="" label="-" suffix="%"
                                :status="inputStatus2" :tips="tips2" :min="0" :max="100" theme="normal" />

                        </t-form-item>
                        <t-button theme="primary" type="submit" class="submit">点击计算（消耗2积分）</t-button>
                    </t-col>
                    <t-col :span="6" style="padding-left: 106px;padding-right: 70px;padding-bottom: 50px;">
                        <div class="right-top-title"><span>计算结果</span></div>
                        <t-form-item label="勘察实物工作收费基价" name="subtotal">
                            <t-input v-model="formData.subtotal" placeholder="" disabled suffix="元"></t-input>
                        </t-form-item>
                        <t-form-item label="勘察实物工作收费" name="surveyObject">
                            <t-input v-model="formData.surveyObject" placeholder="" disabled suffix="元"></t-input>
                        </t-form-item>
                        <t-form-item label="勘查技术工作收费" name="exploitationTechnique">
                            <t-input v-model="formData.exploitationTechnique" placeholder="" disabled
                                suffix="元"></t-input>
                        </t-form-item>
                        <t-form-item label="勘察收费基准价" name="standardPrice">
                            <t-input v-model="formData.standardPrice" placeholder="" disabled suffix="元"></t-input>
                        </t-form-item>
                        <t-form-item label="折前勘察收费" name="standardPrice">
                            <t-input v-model="formData.standardPrice" placeholder="" disabled suffix="元"></t-input>
                        </t-form-item>
                        <t-form-item label="计算过程">
                            <t-textarea v-model="jsgc" placeholder="" disabled
                                :autosize="{ minRows: 3, maxRows: 5 }"></t-textarea>
                        </t-form-item>

                        <t-form-item label="折后勘察收费" name="result">
                            <t-input v-model="formData.result" placeholder="" disabled suffix="元"
                                @change="resultChange"></t-input>
                        </t-form-item>
                        <t-form-item label="金额大写" name="resultChinese">
                            <t-input v-model="resultChinese" placeholder="" disabled></t-input>
                        </t-form-item>

                        <t-button class="download" @click="downLoadWord" :disabled="!formData.result"
                        :loading="downLoading">查看计算过程和报告（消耗5积分）</t-button>
                    </t-col>
                </t-row>





                <!-- 
          <t-form-item style="margin-left: 140px">
            <t-row>
              <t-col :span=12>
                <t-space size="10px">
                  
                  
  
                </t-space>
              </t-col>
              <t-col :span=12 style="margin-top: 10px;">
                <t-button theme="default" variant="base" @click="handleClear" class="help">是否需要详细过程？给点小费求助·</t-button>
              </t-col>
            </t-row>
  
  
  
          </t-form-item> -->
            </t-form>

        </div>
        <div class="calc-rules">
            <t-row>
                <t-col :span="6" style="border-right: 1px solid #DADDE1;">
                    <h4><span>计算范围和计算公式</span></h4>
                </t-col>
                <t-col :span="6">
                    <h4><span>费率标准</span></h4>
                </t-col>
            </t-row>
            <div class="calc-rules-value">
                <t-row style="height: 100%;">
                    <t-col :span="6" style="border-right: 1px solid #DADDE1;height: 100%;overflow: auto;"
                        class='rate-table'>
                        <div class="calc-rules-value-left">
                            <div class="title"><span>计算范围</span></div>
                            <div class="info">{{ calculateRange }}</div>
                            <div class="title" style="margin-top: 33px;"><span>计算公式</span></div>
                            <div class="info" style="white-space: pre-line;">{{ calculationFormula }}</div>
                        </div>
                    </t-col>
                    <t-col :span="6" style="padding: 20px;overflow: auto;" class='rate-table'>
                        <div class="calc-rules-value-right">
                            <t-table bordered row-key="index" :data="data" :columns="columns" />
                            <div style="text-align: left;">注：计价单位km。</div>
                        </div>
                    </t-col>
                </t-row>
            </div>
        </div>
        <t-dialog placement="center" :visible="visible3" :footer="false" :onConfirm="close3" :onClose="close3"
            class="dialog3">
            <span slot="header">
                高程调整系数
                <div class="closeButton" @click="close3"></div>
            </span>
            <p>海拔高程</p>

            <t-radio-group v-model="value3" @change="onChange3">
                <t-space style="margin: 0 auto;">
                    <t-radio value="2001m以下的-1.0">2001m以下的 <span>1.0</span></t-radio>
                    <t-radio value="2001-3000m以下的-1.1">2001-3000m以下的 <span>1.1</span></t-radio>
                </t-space>
                <t-space style="margin: 0 auto;">
                    <t-radio value="3001-3500m以下的-1.2">3001-3500m以下的 <span>1.2</span></t-radio>
                    <t-radio value="3501-4000m以下的-1.3">3501-4000m以下的 <span>1.3</span></t-radio>
                    <t-radio value="4001m以上的，协商确定">4001m以上自定义</t-radio>
                </t-space>
            </t-radio-group>



        </t-dialog>
        <!-- <help v-bind:visible.sync="helpOpen"></help> -->
        <file-view v-bind:visible.sync="visible" :fileUrl="openFileUrl" :downFileUrl="downFileUrl"></file-view>
    </div>
</template>

<script>
import { getdsclf } from '@/api/data'
import { listFile } from "@/api/file";
import { listRate } from "@/api/rate";
// import Help from '@/components/Help.vue'

export default {
    name: 'dsclfFee',
    components: {
        // eslint-disable-next-line vue/no-unused-components
        // Help
    },
    data() {
        return {
            name: null,
            jsgc: null,
            visible: false,
            downFileUrl: null,
            openFileUrl: null,
            downLoading: false,
            value3: '',
            visible3: false,
            validateMessage: {
                projectName: [
                    {
                        type: 'error',
                        message: '项目名称不能为空',
                    },
                ],
                money: [
                    {
                        type: 'error',
                        message: '请输入规范数字',
                    },
                ]

            },
            rules: {
                projectName: [{ required: true }, { type: 'warning' }],
                money: [{ required: true }, { pattern: /^[0-9.]*$/, message: '请输入规范数字', required: true, type: 'warning' }],


            },
            helpOpen: false,
            discountRate: null,
            floatingRange: 80,
            downData: {},//下载时传值
            rateList: [],
            formData: {
                ificationId: this.$route.query.ification,
                projectName: '',
                projectType: '',
                money: null, //实物工作量
                complexCoefficient: '1',//复杂程度
                additionalAdjustments: '1.0',//附加调整
                airCoefficient: '1.0',//气温附加系数
                elevationCoefficient: '1.0',//高度调整
                floatingRate: '80',//浮动率
                //   coefficient: '1.0',  // 调整系数
                subtotal: null, // 勘察实物工作收费基价
                surveyObject: null,//勘察实物工作收费
                exploitationTechnique: null,//勘查技术工作收费
                standardPrice: null,//勘察收费基准价
                // beforeFolding: null,//折前勘察收费
                discountRate: 0,
                discountRateMoney: null,
                //   basicCharge:null,//基本收费
                //   assessmentFee:null,//社会稳定风险评估费
                result: null
            },
            resultChinese: '',
            fileList: [],
            costBasePriceLimit: '20~30',
            costBasePriceMin: 20,
            costBasePriceMax: 30,
            data: [{

            }],

            columns: [
                {
                    title: '序',
                    colKey: 'id',
                    width: 90,
                },
                // {
                //     title: '收费区间值（万元）',
                //     width: 100,
                //     colKey: '-',
                //     children: [
                //         {
                //             colKey: 'startValue',
                //             title: '起值',
                //             width: 100,
                //         },
                //         {
                //             title: '终止',
                //             colKey: 'finalValue',
                //             width: 100,
                //         }
                //     ],
                // },
                {
                    title: '复杂程度',
                    colKey: 'remark',
                    width: 100,
                },
                {
                    title: '收费基价（元）',
                    colKey: 'rate',
                    width: 100,
                },
                


            ],
            calculateRange: null,//计算范围
            calculationFormula: null // 计算公式


        }
    },
    created() {
        this.getList()
    },
    methods: {
        getList() {
            listFile({ classificationId: this.$route.query.ification }).then(response => {
                // console.log(response)
                this.fileList = response.rows[0];

            });
            listRate({ ificationId: this.$route.query.ification }).then(res => {
                let i = 1
                res.rows.forEach((item) => {
                    item.id = i++
                    if (item.finalValue > 99999999) {
                        item.finalValue = ""
                    }
                    this.data.push(item)
                })
                this.data = res.rows
            })
            this.getClassification(this.$route.query.ification || 3).then(res => {
                this.name = res.data.name
                if (res.data.scope) {
                    if (res.data.scope.indexOf("\\n") != -1) {
                        this.calculateRange = res.data.scope.replaceAll('\\n', '\n')
                    } else {
                        this.calculateRange = res.data.scope
                    }

                } else {
                    this.calculateRange = '暂无数据'
                }
                if (res.data.particulars) {
                    if (res.data.particulars.indexOf("\\n") != -1) {
                        this.calculationFormula = res.data.particulars.replaceAll('\\n', '\n')
                    } else {
                        this.calculationFormula = res.data.particulars
                    }
                } else {
                    this.calculationFormula = '暂无数据'
                }
            })
        },
        onReset() {
            this.$message.success('重置成功');
            console.log('formData', this.formData);
        },
        onSubmit({ validateResult, firstError }) {
            if (validateResult === true) {
                this.submit()
                this.$message.success('提交成功');
            } else {
                console.log('Errors: ', validateResult);
                this.$message.warning(firstError);
            }
        },
        downLoadWord(){
      this.downLoading = true;
      let wordParam = {
        xmmc:this.formData.projectName,
        xsz:'实物工作量:' + this.formData.money + 'km;' + `选择复杂程度:${ { 1: "简单", 2: "中等", 3: "复杂" }[this.formData.complexCoefficient]}%;附加调整:${this.formData.additionalAdjustments};气温附加调整:${this.formData.airCoefficient};高程调整:${this.formData.elevationCoefficient};浮动幅度:${this.floatingRange}%;折扣率:${this.discountRate}%。`,
        yjwj:this.fileList ? this.fileList.fileName.split('.')[0] : '--',
       fzcd: { 1: "简单", 2: "中等", 3: "复杂" }[this.formData.complexCoefficient],
       kcjj: this.formData.subtotal,
       gctzxs:this.formData.elevationCoefficient,
       fjtzxs:this.formData.additionalAdjustments,
       qwfjtzxs:this.formData.airCoefficient,

        jsgc:this.jsgc,
        fulx:'洞室测量费',
        zhj:this.formData.result,
      }
      this.download('/project/dscl/word', { id: this.downData.id, classId: 51,...wordParam }
        , `勘察费.docx`).then(res => {
          console.log(res)
          this.downLoading = false
        }
        )
    },
        handleClear() {
            this.helpOpen = true
        },
        submit() {
            this.formData.discountRate = Number(this.discountRate) / 100
            this.formData.floatingRate = Number(this.floatingRange) / 100
            getdsclf(this.formData).then(res => {
                this.downData = res.data
                this.formData.money = res.data.money.toString()
                this.formData.discountRateMoney = res.data.discountRateMoney.toFixed(2).toString()
                this.formData.result = res.data.result.toFixed(2).toString()
                this.formData.subtotal = res.data.subtotal.toFixed(2).toString()
                this.formData.surveyObject = res.data.surveyObject.toFixed(2).toString()
                this.formData.exploitationTechnique = res.data.exploitationTechnique.toFixed(2).toString()
                this.formData.standardPrice = res.data.standardPrice.toFixed(2).toString()
                this.formData.beforeFolding = res.data.beforeFolding && res.data.beforeFolding.toFixed(2).toString()
                // this.formData.money.toString()
                this.resultChinese = this.changeNumMoneyToChinese(Number(this.formData.result))
                this.jsgc = res.data.jsgc
            })
        },
        resultChange(value) {
            this.resultChinese = this.changeNumMoneyToChinese(value)
        },
        openVisible3() {
            this.visible3 = true
        },
        close3() {
            this.visible3 = false;
        },
        onChange3(checkedValues) {
            //   console.log('checkedValues:', this.value3, checkedValues.split('-').slice(-1));
            if (checkedValues.split('-').slice(-1) == '4001m以上的，协商确定') {
                this.formData.elevationCoefficient = null
            } else {
                this.formData.elevationCoefficient = checkedValues.split('-').slice(-1).toString()
            }

        },
        fileOpenDialog(url) {
      this.downFileUrl = url
      let fileUrl = '/pdfjs/web/viewer.html?file=' + process.env.VUE_APP_BASE_API + url
      // window.open(fileUrl,'_blank')
      this.openFileUrl = fileUrl
      this.visible = true
    }

    },
    computed: {
        inputStatus() {
            if (this.formData.costBasePrice < this.costBasePriceMin || this.formData.costBasePrice > this.costBasePriceMax) {
                return 'error';
            } if (isNaN(+this.formData.costBasePrice)) {
                return 'warning';
            }
            return '';
        },
        tips() {
            if (this.inputStatus == 'error') {
                return '请输入合理区间数字';
            } else if (this.inputStatus == 'warning') {
                return '请输入规范数字';
            }
            return '';
        },
        inputStatus2() {
            if (isNaN(+this.discountRate)) {
                return 'error';
            }
            return '';
        },
        tips2() {
            if (!this.inputStatus2) {
                return '';
            }
            return '请输入数字';
        },
        inputStatus3() {
            if (this.floatingRange < 80 || this.floatingRange > 120) {
                return 'error';
            }
            return '';
        },
        tips3() {
            if (!this.inputStatus3) {
                return '';
            }
            return '超出国定范围';
        },
    },

}
</script>

<style lang="less">
.dsclf {
    background: #ffffff;
    width: 1168px;
    margin: 0 auto;
    border: 1px solid #e3e6ea;
    padding-bottom: 38px;


    

    

    

    .dialog3 {
        .t-dialog__close {
            display: none;
        }

        .t-dialog {
            width: 902px;
            height: 200px;
            border-radius: 4px;
            opacity: 1;
            border: 1px solid #e3e6ea;
            padding: 0;
            // padding-bottom: 32px;

            .t-dialog__header {
                height: 57px;
                opacity: 1;
                background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
                border-bottom: 1px solid #f5f5f5;

                .t-dialog__header-content {
                    display: block;
                    margin-left: 24px;
                    position: relative;
                }

                .closeButton {
                    background: url('@/assets/icon/button_cleaner-3nosha.svg');
                    width: 24px;
                    height: 24px;
                    content: "  ";
                    float: right;
                    right: 24px;
                    position: relative;
                    cursor: pointer;
                }
            }

            .t-dialog__body {
                padding: 0;
                background: url('@/assets/dialog-background.png');
                height: 150px;

                p {
                    height: 22px;
                    opacity: 1;
                    color: #0655de;
                    font-size: 16px;
                    font-weight: 500;
                    font-family: 'Medium';
                    text-align: center;
                    line-height: 22px;
                    letter-spacing: -0.01px;
                    margin-top: 20px;
                    margin-bottom: 15px;
                }

                .t-radio__label {
                    height: 22px;
                    opacity: 1;
                    color: #606266;
                    font-size: 14px;
                    font-weight: 500;
                    font-family: 'Medium';
                    text-align: left;
                    line-height: 22px;
                    letter-spacing: -0.01px;

                    span {
                        color: #000000;
                    }
                }
            }
        }
    }
}
</style>